import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { ptBR } from './locales/pt-BR';
import { en } from './locales/en';
import { es } from './locales/es';
import { zhCN } from './locales/zh-CN';
export const SUPPORTED_LOCALES = ['pt-BR', 'en', 'es', 'zh-CN'];
export const DEFAULT_LOCALE = 'pt-BR';
/**
 * Translation pattern (v1):
 *
 *  - `pt-BR` is the canonical locale. `en` and `es` use `satisfies typeof ptBR`
 *    so the TypeScript compiler fails the build when a key is missing.
 *  - Keys are flat-per-screen: `home.*`, `platforms.*`, `legal.*`, `common.*`.
 *  - No nesting beyond 3 levels.
 *  - Dynamic data from the API (e.g. platform kind) is mapped to keys on the
 *    frontend — the backend never returns localized strings.
 *  - Browser language is auto-detected. An explicit user choice is persisted
 *    in `localStorage[supadown:lang]` and wins over the detected value.
 *
 * Resource aliases below exist so bare codes (`pt`, `en`, `es`) and the most
 * common region variants resolve without triggering the "missing key" fallback
 * of i18next (which would render raw keys like `home.tagline`).
 */
void i18n.use(LanguageDetector).use(initReactI18next).init({
    resources: {
        'pt-BR': { translation: ptBR },
        'pt': { translation: ptBR },
        'pt-PT': { translation: ptBR },
        'en': { translation: en },
        'en-US': { translation: en },
        'en-GB': { translation: en },
        'es': { translation: es },
        'es-ES': { translation: es },
        'es-419': { translation: es },
        'es-MX': { translation: es },
        'es-AR': { translation: es },
        'zh-CN': { translation: zhCN },
        'zh': { translation: zhCN },
        'zh-Hans': { translation: zhCN },
    },
    fallbackLng: {
        'pt': ['pt-BR'],
        'pt-PT': ['pt-BR'],
        'en-US': ['en'],
        'en-GB': ['en'],
        'es-ES': ['es'],
        'es-AR': ['es'],
        'es-MX': ['es'],
        'es-419': ['es'],
        'zh': ['zh-CN'],
        'zh-Hans': ['zh-CN'],
        default: [DEFAULT_LOCALE],
    },
    supportedLngs: [
        'pt-BR', 'pt', 'pt-PT',
        'en', 'en-US', 'en-GB',
        'es', 'es-ES', 'es-419', 'es-MX', 'es-AR',
        'zh-CN', 'zh', 'zh-Hans',
    ],
    nonExplicitSupportedLngs: true,
    detection: {
        order: ['localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
        lookupLocalStorage: 'supadown:lang',
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
});
export default i18n;
